// Fichiers générés par l'assistant (Excel, PDF, Word) : liens /download/<dossier>/<uuid>/<nom>
// écrits dans la réponse. Le lien reste relatif : servi par le même domaine (nginx en
// production, proxy Vite en développement).

const DOWNLOAD_RE = /\/download\/[^\s)"'\]<>]+/g;

export const FILE_TYPES = {
  pdf: { label: 'Document PDF', short: 'PDF', previewable: true },
  xlsx: { label: 'Classeur Excel', short: 'Excel', previewable: false },
  docx: { label: 'Document Word', short: 'Word', previewable: false },
  pptx: { label: 'Présentation PowerPoint', short: 'PowerPoint', previewable: false },
  csv: { label: 'Fichier CSV', short: 'CSV', previewable: false },
};

export function fileInfo(url) {
  const path = url.split(/[?#]/)[0];
  const raw = path.split('/').pop() || 'fichier';
  let name = raw;
  try { name = decodeURIComponent(raw); } catch { /* nom laissé tel quel */ }
  const ext = (name.split('.').pop() || '').toLowerCase();
  return { url: path, name, ext, type: FILE_TYPES[ext] ?? { label: 'Fichier', short: ext.toUpperCase() || 'Fichier', previewable: false } };
}

/** Fichiers téléchargeables cités dans une réponse (sans doublon, dans l'ordre). */
export function extractFiles(content) {
  if (typeof content !== 'string') return [];
  const seen = new Set();
  const out = [];
  for (const match of content.matchAll(DOWNLOAD_RE)) {
    const url = match[0].replace(/[.,;:]+$/, '');
    if (seen.has(url)) continue;
    seen.add(url);
    out.push(fileInfo(url));
  }
  return out;
}

const units = ['o', 'Ko', 'Mo', 'Go'];
const nf1 = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 1 });
export function formatBytes(bytes) {
  if (bytes == null || Number.isNaN(bytes)) return null;
  let value = bytes;
  let unit = 0;
  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024;
    unit += 1;
  }
  return `${nf1.format(value)} ${units[unit]}`;
}
